export enum TasksRoutesEnum {
  DesktopTasks = '/home/desktop/tasks',
  DesktopTasksMap = '/home/desktop/tasks/map',
}
